import React, { useContext, useEffect, useState } from "react";
import { Menu, type MenuProps, theme } from "antd";
import Sider from "antd/es/layout/Sider";
import { useNavigate, useLocation } from "react-router-dom";
import { RiDatabase2Fill, RiFileList3Fill, RiHome2Fill } from "react-icons/ri";
import { GoHome } from "react-icons/go";
import { FaDatabase, FaLayerGroup, FaBookOpen } from "react-icons/fa";
import { PiCodeBlock, PiStudent, PiExam } from "react-icons/pi";
import { FaRankingStar } from "react-icons/fa6";
import { VscCode } from "react-icons/vsc";
import { AuthContext } from "../../../config/AuthContext";

interface Props {
    currentVal: number;
    setPantalla?: (value: number) => void;
}

const AppSider = (props: Props) => {
    const { isLoggedIn, user } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        document.title = 'Base de Dades';
    }, []);

    const isTeacher = user?.tipus === "0" || user?.tipus === "1";

    // --- STUDENT MENU ---
    const rawStudentMenu = [
        { key: 'Home', icon: GoHome, text: 'Home', href: '/database' },
        { key: 'Problemes', icon: FaDatabase, text: 'Problemes', href: '/database/problemes' },
        { key: 'Activitats', icon: PiCodeBlock, text: 'Activitats', href: '/database/activitats' },
        { key: 'Exàmens', icon: PiExam, text: 'Exàmens', href: '/database/examens' },
        { key: 'Rànquing', icon: FaRankingStar, text: 'Rànquing', href: '/database/ranking' },
        { key: 'Píldores', icon: FaBookOpen, text: 'Píldores', href: '/database/pildores' },
        { key: 'IDE SQL', icon: VscCode, text: 'IDE SQL', href: '/database/ide/frame' },
    ];

    const itemsStudent: MenuProps['items'] = rawStudentMenu.map((item) => ({
        key: item.key,
        icon: React.createElement(item.icon),
        label: item.text,
        onClick: () => {
            if (item.key === 'IDE SQL') {
                window.open(item.href, '_blank');
            } else {
                navigate(item.href);
            }
        }
    }));

    // --- TEACHER / ADMIN MENU ---
    const rawTeacherMenu = [
        { key: 'Home', icon: GoHome, text: 'Home', href: '/database' },
        { key: 'Problemes', icon: FaDatabase, text: 'Problemes', href: '/database/problemes' },
        { key: 'Activitats', icon: PiCodeBlock, text: 'Activitats', href: '/database/activitats' },
        { key: 'Exàmens', icon: PiExam, text: 'Exàmens', href: '/database/examens' },
        { key: 'Bases de Dades', icon: RiDatabase2Fill, text: 'Bases de Dades', href: '/database/aules-bbdd' },
        { key: 'Notes', icon: PiStudent, text: 'Notes', href: '/database/notes' },
        { key: 'Rànquing', icon: FaRankingStar, text: 'Rànquing', href: '/database/ranking' },
        { key: 'Píldores', icon: FaBookOpen, text: 'Píldores', href: '/database/pildores' },
        { key: 'IDE SQL', icon: VscCode, text: 'IDE SQL', href: '/database/ide/frame' },
    ];

    const itemsTeacher: MenuProps['items'] = rawTeacherMenu.map((item) => ({
        key: item.key,
        icon: React.createElement(item.icon),
        label: item.text,
        onClick: () => {
            if (item.key === 'IDE SQL') {
                window.open(item.href, '_blank');
            } else {
                navigate(item.href);
            }
        }
    }));


    const {
        token: { colorBgContainer },
    } = theme.useToken();

    // Map numeric currentVal fallback
    const currentValToText: Record<number, string> = {
        0: 'Home',
        1: 'Problemes',
        2: 'Activitats',
        3: 'Exàmens',
        4: 'Notes',
        5: 'Rànquing',
        6: 'Píldores',
        7: 'IDE SQL',
        8: 'Bases de Dades'
    };

    let activeKey = currentValToText[props.currentVal] || 'Home';

    // Highlight key dynamically based on current route
    const currentPath = location.pathname.toLowerCase();
    if (currentPath.includes('/database/examens')) {
        activeKey = 'Exàmens';
    } else if (currentPath.includes('/database/activitats')) {
        activeKey = 'Activitats';
    } else if (currentPath.includes('/database/problemes')) {
        activeKey = 'Problemes';
    } else if (currentPath.includes('/database/aules-bbdd')) {
        activeKey = 'Bases de Dades';
    } else if (currentPath.includes('/database/notes')) {
        activeKey = 'Notes';
    } else if (currentPath.includes('/database/ranking')) {
        activeKey = 'Rànquing';
    } else if (currentPath.includes('/database/pildores')) {
        activeKey = 'Píldores';
    } else if (currentPath.includes('/database/ide')) {
        activeKey = 'IDE SQL';
    } else if (currentPath === '/database' || currentPath === '/database/') {
        activeKey = 'Home';
    }

    return (
        <Sider style={{ background: colorBgContainer }} width={200}>
            <Menu
                mode="inline"
                selectedKeys={[activeKey]}
                style={{ height: '100%', borderRight: 0 }}
                items={isTeacher ? itemsTeacher : itemsStudent}
            />
        </Sider>
    );
};

export default AppSider;
